export default {
  geolocation: {
    lat: '45.4215',
    lng: '75.6972',
    label: 'K0A Ottawa',
  },
  price_rules: {
    grouping: ',',
    decimal: '.',
  },
}
